import SkeletonLoader from './index';

const StudentDetailDrawerSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full">
      {/* Header Profile Section */}
      <div className="flex flex-col items-center gap-4 w-full">
        <SkeletonLoader variant="circle" width={100} height={100} />
        <SkeletonLoader width={200} height={32} />
        <SkeletonLoader width={100} height={24} className="rounded-full" />

        <div className="flex items-center justify-center gap-8 w-full mt-2">
          <SkeletonLoader width={80} height={20} />
          <SkeletonLoader width={80} height={20} />
        </div>
      </div>

      {/* Personal Info Section */}
      <div className="grid sm:grid-cols-2 gap-6 w-full">
        <div className="flex items-start gap-2">
          <SkeletonLoader variant="circle" width={24} height={24} />
          <div className="flex flex-col gap-1 flex-1">
            <SkeletonLoader width={100} height={16} />
            <SkeletonLoader width={150} height={20} />
          </div>
        </div>
        <div className="flex items-start gap-2">
          <SkeletonLoader variant="circle" width={24} height={24} />
          <div className="flex flex-col gap-1 flex-1">
            <SkeletonLoader width={100} height={16} />
            <SkeletonLoader width={150} height={20} />
          </div>
        </div>
      </div>

      {/* Learning Overview Section */}
      <div className="flex flex-col gap-4 w-full">
        <SkeletonLoader width={150} height={24} />
        <div className="border border-neutral-200 rounded-2xl p-4 space-y-6">
          <div className="flex flex-col gap-2">
            <div className="flex justify-between">
              <SkeletonLoader width={100} height={20} />
              <SkeletonLoader width={40} height={20} />
            </div>
            <SkeletonLoader height={8} className="rounded-lg" />
          </div>

          <div className="flex gap-4">
            {[1, 2, 3].map((_, index) => (
              <div key={index} className="flex-1 h-20">
                <SkeletonLoader height="100%" className="rounded-lg" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Learning Modules Section */}
      <div className="flex flex-col gap-4 w-full">
        <SkeletonLoader width={150} height={24} />
        <div className="space-y-4">
          {[1, 2].map((_, index) => (
            <div
              key={index}
              className="border border-neutral-200 rounded-2xl p-4"
            >
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-end">
                  <div className="flex flex-col gap-1">
                    <SkeletonLoader width={120} height={20} />
                    <SkeletonLoader width={80} height={16} />
                  </div>
                  <SkeletonLoader width={40} height={24} />
                </div>
                <SkeletonLoader height={8} className="rounded-lg" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudentDetailDrawerSkeleton;
